import { useState, useRef, useEffect } from 'react';

function useDragHandle(containerRef, callbacks) {
  const [isDragging, setDragging] = useState(false);
  const [offset, setOffset] = useState(0);
  const callbackRefs = useRef(callbacks);
  callbackRefs.current = callbacks;
  useEffect(() => {
    const container = containerRef.current;
    if (!container) {
      return;
    }
    const preventScroll = evt => {
      evt.preventDefault();
    };
    const onPointerDown = evt => {
      if (!evt.isPrimary) {
        return;
      }
      callbackRefs.current.onDragBegin();
      evt.preventDefault();
      window.addEventListener("touchmove", preventScroll, {
        passive: false
      });
      window.addEventListener("pointermove", updateDragHandlePosition);
      window.addEventListener("pointerup", onPointerEnd);
      window.addEventListener("pointercancel", onPointerEnd);
      window.addEventListener("pointerleave", onPointerEnd);
    };
    const updateDragHandlePosition = evt => {
      evt.preventDefault();
      const rect = container.getBoundingClientRect();
      const offset = (evt.clientX - rect.left) / rect.width;
      setOffset(Math.min(1, Math.max(0, offset)));
      setDragging(true);
    };
    const onPointerEnd = evt => {
      evt.preventDefault();
      const rect = container.getBoundingClientRect();
      const offset = (evt.clientX - rect.left) / rect.width;
      callbackRefs.current.onDragEnded(Math.min(1, Math.max(0, offset)));
      window.removeEventListener("touchmove", preventScroll);
      window.removeEventListener("pointermove", updateDragHandlePosition);
      window.removeEventListener("pointerup", onPointerEnd);
      window.removeEventListener("pointercancel", onPointerEnd);
      window.removeEventListener("pointerleave", onPointerEnd);
      setTimeout(() => {
        setDragging(false);
      }, 50);
    };
    container.addEventListener("pointerdown", onPointerDown);
    return () => {
      container.removeEventListener("pointerdown", onPointerDown);
      window.removeEventListener("touchmove", preventScroll);
      window.removeEventListener("pointermove", updateDragHandlePosition);
      window.removeEventListener("pointerup", onPointerEnd);
      window.removeEventListener("pointercancel", onPointerEnd);
      window.removeEventListener("pointerleave", onPointerEnd);
    };
  }, [containerRef]);
  return [isDragging, offset];
}

export { useDragHandle };
//# sourceMappingURL=hook.drag-handle.js.map
